// extracted by mini-css-extract-plugin
export default {"root":"_3fHDu","content":"_2xEQX","message":"_23DDh"};